import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import { isEmpty } from "lodash";

const fetchTestimonials = async (isTestimonial, searchKey) => {
  return await axios.get(
    API_URL +
      `/api/Testimonial/GetTestimonialsByType/${isTestimonial}${
        !isEmpty(searchKey) ? "?SearchBy=" + searchKey : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const deleteTestimonial = (id) => {
  return axios.post(
    API_URL + `/api/Testimonial/DeleteTestimonials/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

const fetchTestimonialById = async (id) => {
  return await axios.get(
    API_URL + `/api/Testimonial/GetTestimonialsById/${id}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchTestimonial = (isTestimonial, searchKey) => {
  return useQuery({
    queryKey: ["testimonials"],
    queryFn: () => fetchTestimonials(isTestimonial, searchKey),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteTestimonial = (id) => {
  return useMutation(() => deleteTestimonial(id));
};

export const useFetchTestimonialById = (id) => {
  return useQuery({
    queryKey: [`testimonial-${id}`],
    queryFn: () => fetchTestimonialById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

//get testimonial by key location

const fetchTestimonialsByKeyLocation = async (keyLocation) => {
  return await axios.get(
    API_URL + `/api/Testimonial/GetTestimonials/${keyLocation}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchTestimonialByKeyLocation = (keyLocation) => {
  return useQuery({
    queryKey: ["testimonialsByKeyLocation"],
    queryFn: () => fetchTestimonialsByKeyLocation(keyLocation),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

//bulk add testimonials

const bulkAddTestimonials = (fields) => {
  return axios.post(
    API_URL + `/api/Degree/BulkDegreeTestimonialLinks`,
    fields,
    {
      headers: securityHeaders,
    }
  );
};

export const useBulkAddTestimonials = () => {
  return useMutation(bulkAddTestimonials);
};

